

















































































































































































import Vue from 'vue';
import SaveData from '@/classes/saveData/saveData';
import SaveDataTooltip from '@/components/saveData/SaveDataTooltip.vue';

export default Vue.extend({
  name: 'SaveItem',
  components: {
    SaveDataTooltip,
  },
  props: {
    value: {
      type: SaveData,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    handleDelete: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    editDialog: false,
    deleteConfirmDialog: false,
    editedName: '',
    editedRemarks: '',
    enabledTooltip: false,
    tooltipTimer: undefined as undefined | number,
    tooltipData: new SaveData(),
    tooltipX: 0,
    tooltipY: 0,
  }),
  computed: {
    saveData(): SaveData {
      return this.value;
    },
    isNameEmpty(): boolean {
      return this.editedName.length <= 0;
    },
  },
  updated() {
    if (this.value.highlight) {
      // 光り終わったら消す通知
      setTimeout(() => {
        const saveData = this.$store.state.saveData as SaveData;
        saveData.clearHighlight();
        this.$store.dispatch('updateSaveData', saveData);
      }, 1600);
    }
  },
  methods: {
    handleUpdateSaveData(): void {
      // セーブデータの更新を通知
      const saveData = this.$store.state.saveData as SaveData;
      saveData.sortChild();
      this.$store.dispatch('updateSaveData', saveData);
    },
    itemClicked(): void {
      const data = this.saveData;
      data.selected = true;
      if (!data.isDirectory) {
        if (data.isActive && data.isMain) {
          // 何度もやらせない
          return;
        }
        // ルートのセーブデータを取得し、いったん全てのメイン状態を解除
        const saveData = this.$store.state.saveData as SaveData;
        saveData.disabledMain();

        // クリックされたこれをメイン状態とする
        data.isActive = true;
        data.isMain = true;
        this.$store.dispatch('setMainSaveData', data);

        this.handleUpdateSaveData();
        if (!this.$route.path.endsWith('/aircalc')) {
          // ページ遷移
          this.$router.push('aircalc');
        }
        return;
      }
      data.isOpen = !data.isOpen;
    },
    copyAndOpen() {
      const data = this.saveData;
      if (!data.isDirectory) {
        // ルートのセーブデータを取得し、いったん全てのメイン状態を解除
        const saveData = this.$store.state.saveData as SaveData;
        saveData.disabledMain();

        // クリックされたこれを複製
        const newData = new SaveData();
        newData.name = `${data.name}_コピー`;
        newData.manager = data.manager;
        newData.isActive = true;
        newData.isMain = true;

        saveData.childItems.push(newData);
        this.$store.dispatch('setMainSaveData', newData);

        this.handleUpdateSaveData();
        if (!this.$route.path.endsWith('/aircalc')) {
          // ページ遷移
          this.$router.push('aircalc');
        }
        return;
      }
      data.isOpen = !data.isOpen;
    },
    onClickOutside(): void {
      this.saveData.selected = false;
    },
    deleteData() {
      this.deleteConfirmDialog = false;
      this.handleDelete(this.index);
    },
    deleteChild(index: number) {
      // データの削除は常にこのメソッドにより行われる
      this.value.childItems = this.value.childItems.filter((v, i) => i !== index);
      // 更新を通知
      this.handleUpdateSaveData();

      // メイン計算データの削除がされていないかチェック されていたら更新通知 => 計算画面だったらトップページに戻ってくれる
      const saveData = this.$store.state.saveData as SaveData;
      if (!saveData.getMainData()) {
        this.$store.dispatch('setMainSaveData', undefined);
      }
    },
    showEditDialog() {
      this.editedName = this.value.name;
      this.editedRemarks = this.value.remarks ? this.value.remarks : '';
      this.editDialog = true;
    },
    commitName() {
      this.editDialog = false;
      this.value.name = this.editedName.trim();
      this.value.remarks = this.editedRemarks ? this.editedRemarks.trim() : '';
      this.value.editedDate = Date.now();
      this.handleUpdateSaveData();
    },
    dragStart(e: DragEvent) {
      this.clearTooltip();
      const target = e.target as HTMLDivElement;
      target.style.opacity = '0.6';
      target.id = 'dragging-item';

      // ドラッグ中セーブデータを一時保持
      this.$store.dispatch('setDraggingSaveData', this.value);

      const itemList = document.getElementsByClassName('save-list');
      for (let i = 0; i < itemList.length; i += 1) {
        itemList[i].classList.add('dragging');
      }
    },
    dragLeave(e: DragEvent) {
      (e.target as HTMLDivElement).style.backgroundColor = '';
    },
    dragEnter(e: DragEvent): void {
      const draggingDiv = document.getElementById('dragging-item');
      const target = e.target as HTMLDivElement;
      if (!draggingDiv || !target || !this.value.isDirectory) {
        return;
      }
      // 受け入れ可能 背景色を青っぽく
      target.style.backgroundColor = 'rgba(20, 160, 255, 0.8)';
    },
    dropItem(e: DragEvent) {
      // 受け渡されたデータ
      const draggingDiv = document.getElementById('dragging-item');
      // そもそもドラッグ開始が正常になされているか
      if (!draggingDiv) {
        return;
      }

      // ドロップされる要素
      const target = e.target as HTMLDivElement;
      target.style.backgroundColor = '';
      if (target.id) {
        // 自身へのドロップ禁止
        return;
      }

      // 一時退避していたデータをセット
      const moveData = this.$store.state.draggingSaveData as SaveData;
      const childIds = moveData.getAllDataId();
      if (!this.value.isDirectory || childIds.includes(this.value.id)) {
        // 自身がファイルじゃなかったり、子孫データに対して自分を入れようとした場合は無理
        return;
      }

      this.value.childItems.push(moveData);

      draggingDiv.classList.add('move-ok');
    },
    dragEnd(e: DragEvent) {
      const target = e.target as HTMLDivElement;
      target.style.opacity = '1';

      target.id = '';
      if (target.classList.contains('move-ok')) {
        this.deleteData();
        target.classList.remove('move-ok');
      }

      const itemList = document.getElementsByClassName('save-list');
      for (let i = 0; i < itemList.length; i += 1) {
        itemList[i].classList.remove('dragging');
      }
    },
    bootTooltip(data: SaveData, e: MouseEvent) {
      if (data.isDirectory) {
        return;
      }
      const nameDiv = (e.target as HTMLDivElement).closest('.save-list')?.getElementsByClassName('item-name')[0] as HTMLDivElement;
      this.tooltipTimer = window.setTimeout(() => {
        const rect = nameDiv.getBoundingClientRect();
        this.tooltipX = rect.x;
        this.tooltipY = rect.y + rect.height + 30;
        this.tooltipData = data;
        this.enabledTooltip = true;
      }, 200);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
  },
});
